import { gql } from '@apollo/client';

import { AIEmailHandlingAction } from 'shared/models/ai-email-handling-tracker';

export interface AIEmailHandlingData {
    personId: string;
    jobId: string;
    action: AIEmailHandlingAction;
    responseCategory: string;
    analysis: string[];
    responseText: string | null;
    replyToMessageId: string | null;
    replyToAccount: string | null;
    stage: string | null;
    generationInfo: { inferenceId: string; episodeId: string };
    createdAt: number;
}

export interface LLMOutreachData {
    personId: string;
    jobId: string | null;
    recipientId: string;
    generationInfo: { inferenceId: string; episodeId: string };
    recipient: {
        sends: Array<{ communication: { account: string; messageId: string } }>;
    };
    createdAt: number;
}

export const GetCommunication = gql`
    query GetCommunication($account: String!, $messageId: String!) {
        message: communications_by_pk(account: $account, messageId: $messageId) {
            account
            accountInfo
            messageId
            threadId
            internalDate
            sender
            subject
            snippet
            personIds
            jobIds
            matchData
            headers
            body
            bodyText
            attachments
            bounceReport
            bouncedAddresses
            sideEffectsData
        }
    }
`;

export const CANDIDATE_LATEST_EMAIL_EXCHANGED_AT = gql`
    subscription CandidateLatestEmailExchange($personId: String!, $jobId: String!) {
        candidate: candidates_by_pk(personId: $personId, jobId: $jobId) {
            lastEmailExchangedAt
        }
    }
`;

export const PERSON_LATEST_SCHEDULED_MESSAGE_AT = gql`
    subscription PersonLatestCommunication($personId: String!) {
        messages: scheduled_messages(
            where: { personIds: { _has_key: $personId } }
            limit: 1
            order_by: { modifiedAt: desc }
        ) {
            modifiedAt
        }
    }
`;

export const PERSON_AI_COMMUNICATION_DATA = gql`
    query PersonAICommunicationData($personId: String!) {
        aiEmailActions: ai_email_handling_tracker(
            where: { personId: { _eq: $personId } }
            order_by: { createdAt: desc }
        ) {
            personId
            jobId
            action
            responseCategory
            analysis
            responseText
            replyToMessageId
            replyToAccount
            stage
            generationInfo
            createdAt
        }
        llmOutreaches: tracker_llm_generated_outreaches(
            where: { personId: { _eq: $personId } }
            order_by: { createdAt: desc }
        ) {
            personId
            jobId
            recipientId
            generationInfo
            createdAt
            recipient {
                sends {
                    communication {
                        account
                        messageId
                    }
                }
            }
        }
    }
`;
